export const PaymentMethodEnum = [
  {
    id: 'PAYMENT_LINK',
    method: 'Payment link',
    icon: 'payment-link',
  },
  {
    id: 'BANK_TRANSFER',
    method: 'Bank transfer',
    icon: 'bank-transfer',
  },
  {
    id: 'VIRTUAL_CREDIT_CARD',
    method: 'Virtual credit card',
    icon: 'credit-card',
  },
  {
    id: 'OTHER',
    method: 'Others',
    icon: 'payment-others',
  },
];

export const methodType = {
  PAYMENT_LINK: 'PAYMENT_LINK',
  VIRTUAL_CREDIT_CARD: 'VIRTUAL_CREDIT_CARD',
  BANK_TRANSFER: 'BANK_TRANSFER',
  OTHER: 'OTHER',
};
